import React, {useState} from 'react';
import {IonListHeader, IonButton, IonIcon, IonList, IonItem, IonPopover} from "@ionic/react";
import {addCircleOutline} from "ionicons/icons";
import AplicacaoEvento from "./AplicacaoEvento";

interface AplicacaoMesProps {
  mes: any;
  produtos: any[];
  rebanho: any[];
  setMes: (mes: any) => void;
}

const AplicacaoMes: React.FC<AplicacaoMesProps> = (props) => {
  const {mes} = props;
  const [addVisible, setAddVisible] = useState(false);

  const setCategoria = (catId:number, categoria:any) => {
    const categorias = [];
    for (const i of mes.categorias) {
      if (i.id === catId)
        categorias.push(categoria);
      else
        categorias.push(i);
    }
    props.setMes({
      ...mes,
      categorias,
    });
  };

  const removeCategoria = (catId:number) => {
    const categorias = mes.categorias.filter((i:any) => i.id !== catId);

    props.setMes({
      ...mes,
      categorias,
    });
  };

  const addCategoria = (categoria: any) => {
    props.setMes({
      ...mes,
      categorias: [
        ...mes.categorias,
        {
          ...categoria,
          produtos: [],
        }
      ],
    });
    setAddVisible(false);
  };

  const categoriasAtivas = props.rebanho
    .filter(i => i.num_animais > 0)
    .map(i => ({
      id: i.id,
      nome: i.nome,
      num_animais: i.num_animais,
      peso_medio: i.peso_medio,
    }));

  return (
    <>
      <IonListHeader>
        <div className="flex items-center w-full">
          <div className="flex-grow">
            {mes.nome}
          </div>
          <div>
            <IonButton
              fill="clear"
              onClick={() => setAddVisible(true)}
            >
              <IonIcon
                icon={addCircleOutline}
                slot="icon-only"
              />
            </IonButton>
          </div>
        </div>

      </IonListHeader>
      <div>
        {
          mes.categorias.map((cat: any) => (
            <AplicacaoEvento
              key={cat.id}
              categoria={cat}
              produtos={props.produtos}
              setCategoria={nCat => setCategoria(cat.id, nCat)}
              removeCategoria={removeCategoria}
            />
          ))
        }
      </div>

      <IonPopover
        isOpen={addVisible}
        onDidDismiss={() => setAddVisible(false)}
        className="calendario-evento-edit-popover"
      >
        <AddCategoria
          categorias={categoriasAtivas}
          selecionadosIds={mes.categorias.map((i: any) => i.id)}
          setClose={() => setAddVisible(false)}
          onConfirm={addCategoria}
        />
      </IonPopover>
    </>
  );
}

export default AplicacaoMes;


interface AddCategoriaProps {
  categorias: any[];
  selecionadosIds: number[];
  setClose: () => void;
  onConfirm: (categoria:any) => void;
}

const AddCategoria: React.FC<AddCategoriaProps> = (props) => {
  return (
    <div className="flex">
      <div className="flex-grow">
        <IonList>
          <IonListHeader className="mb-4">
            Categorias
          </IonListHeader>
          {
            props.categorias.map((p: any) => (
              <IonItem
                key={p.id}
                disabled={props.selecionadosIds.indexOf(p.id) !== -1}
                button={true}
                onClick={() => props.onConfirm(p)}
              >
                {p.nome}
              </IonItem>
            ))
          }
        </IonList>
      </div>
    </div>
  );
}
